import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';
import { Stage } from '../../model';
import * as graphicLibs from '../../../graphicLibs/index';
import { BUILDING_TYPE_MANSION} from '../../Constants';

export default class RoomText {
    titleObj: SVGElement;

    sizeObj: SVGElement;

    ceilingObj: SVGElement;

    groupObj: SVGElement;

    x: number;

    y: number;

    offsetPoint: marietta.core.Point;

    rotation: number;

    private dragInitX: number;

    private dragInitY: number;

    public spt: SVGSprite;

    protected titleObjSpt:SVGSprite;

    protected sizeObjSpt:SVGSprite;

    public parentLayer: marietta.webcad.layer.RoomTextLayer;

    private sptTitle: SVGSprite;

    public currentString: string;

    private previousPosition: marietta.core.Point;

    public moveTextActive = false;

    // 表示非表示
    _visible: boolean;

    set visible(booValue: boolean) {
      this._visible = booValue;

      // データに保持
      this.partnerRoom.itemInfo.text_visible = this._visible;

      this.titleObj.style.visibility = booValue ? 'visible' : 'hidden';
      this.titleObj.style.visibility = booValue ? 'visible' : 'hidden';

      if (!booValue) {
        // this._areaVisible = booValue;
        // this.sizeObj.style.visibility = booValue?"visible":"hidden";
      }
      this.sizeObj.style.visibility = (booValue && this._areaVisible) ? 'visible' : 'hidden';
      this.ceilingObj.style.visibility = (booValue && this._ceilingHeightVisible) ? 'visible' : 'hidden';
    }

    get visible() { return this._visible; }

    // サイズ表示
    _areaVisible: boolean;

    set areaVisible(booValue: boolean) {
      this._areaVisible = booValue;

      // データに保持
      this.partnerRoom.itemInfo.text_area_visible = this._areaVisible;
      this.sizeObj.style.visibility = (booValue && this._visible) ? 'visible' : 'hidden';
    }

    get areaVisible() { return this._areaVisible; }

    // 天井高さ表示
    _ceilingHeightVisible: boolean;
    set ceilingHeightVisible(booValue: boolean) {
      this._ceilingHeightVisible = booValue;

      // データに保持
      this.partnerRoom.itemInfo.text_ceiling_visible = this._ceilingHeightVisible;
      this.ceilingObj.style.visibility = (booValue && this._visible) ? 'visible' : 'hidden';
    }

    get ceilingHeightVisible() { return this._ceilingHeightVisible; }

    // 帖表示
    _useJyou: boolean;

    set useJyou(booValue: boolean) {
      this._useJyou = booValue;
      this.updateSizeText();
    }

    get useJyou() { return this._useJyou; }

    // 表示テキスト
    _message: string;

    get message() { return this._message; }

    set message(roomName: string) {
      this._message = roomName;
      if (this.titleObj) {
        this.titleObj.textContent = this._message;
      }
    }

    _autoLayout: boolean;

    get autoLayout() { return this._autoLayout; }

    set autoLayout(value: boolean) {
      this._autoLayout = value;
      if (this._autoLayout) {
        this.resetRoomNamePosition();
      }
    }

    partnerRoom: marietta.webcad.item.Room;

    /**
     * コンストラクタ
     */
    constructor(_partnerRoom: marietta.webcad.item.Room) {
      this.partnerRoom = _partnerRoom;
      // 情報の保持
      this._message = _partnerRoom.itemInfo.text;
      this._visible = this.partnerRoom.itemInfo.text_visible;
      this._useJyou = this.partnerRoom.itemInfo.area_use_jyou;
      this._areaVisible = this.partnerRoom.itemInfo.text_area_visible;
      this._ceilingHeightVisible = this.partnerRoom.itemInfo.text_ceiling_visible;
      this.autoLayout = this.partnerRoom.itemInfo.auto_layout;
      this.x = 0;
      this.y = 0;
      if (this.partnerRoom.itemInfo.textPosition != null && this.partnerRoom.itemInfo.textPosition) {
        if (!Number.isNaN(this.partnerRoom.itemInfo.textPosition.x)) {
          this.x = this.partnerRoom.itemInfo.textPosition.x;
        }
        if (!Number.isNaN(this.partnerRoom.itemInfo.textPosition.y)) {
          this.y = this.partnerRoom.itemInfo.textPosition.y;
        }
      }

      // グループ作成
      this.parentLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer('rnm', this.partnerRoom.itemInfo.floor) as marietta.webcad.layer.RoomTextLayer;
      const viewObj: SVGElement = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', `roomText_${_partnerRoom.itemInfo.guid}`);

      this.groupObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.groupObj.setAttribute('id', `roomTextG_${this.partnerRoom.itemInfo.guid}`);
      this.groupObj.setAttribute('transform', 'translate( 0, 0)');

      // 部屋名
      this.titleObj = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      this.titleObj.setAttribute('id', `roomText_${_partnerRoom.itemInfo.guid}_title`);
      this.titleObj.setAttribute('fill', '#000000');
      this.titleObj.textContent = _partnerRoom.itemInfo.text;
      this.titleObj.setAttribute('class', 'roomText_title');
      this.titleObj.setAttribute("font-size", marietta.webcad.WebCADGlobal.roomtextFontSize.toString() + 'px');
      this.groupObj.appendChild(this.titleObj);

      // サイズ表記
      this.sizeObj = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      this.sizeObj.setAttribute('id', `roomText_${_partnerRoom.itemInfo.guid}_size`);
      this.sizeObj.textContent = _partnerRoom.itemInfo.text;
      this.sizeObj.setAttribute('class', 'roomText_size');
      this.sizeObj.setAttribute("font-size", marietta.webcad.WebCADGlobal.roomtextFontSize.toString() + 'px');
      this.groupObj.appendChild(this.sizeObj);

      this.ceilingObj = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      this.ceilingObj.setAttribute('id', `roomText_${_partnerRoom.itemInfo.guid}_ceiling`);
      this.ceilingObj.setAttribute('fill', '#000000');
      this.ceilingObj.setAttribute('class', 'roomText_ceiling');
      this.ceilingObj.setAttribute("font-size", marietta.webcad.WebCADGlobal.roomtextFontSize.toString() + 'px');
      this.ceilingObj.addEventListener( 'click', ()=>{
        marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoomSetting, false, true, true, true, {targetRooms:[this.partnerRoom]} );
      } );
      // タイトル/サイズ表記と違い ceilingObj はクリック可能なため mouseEnabled=false にできない。
      // 対応するmousedown/touchstartを止めないと、背景レイヤーまでイベントが伝播し複数選択状態がクリアされてしまう。
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.ceilingObj.addEventListener('touchstart', (event: TouchEvent) => { event.stopPropagation(); });
      } else {
        this.ceilingObj.addEventListener('mousedown', (event: MouseEvent) => { event.stopPropagation(); });
      }
      this.groupObj.appendChild(this.ceilingObj);
      viewObj.appendChild(this.groupObj);

      this.spt = new SVGSprite(viewObj);
      this.spt.x = this.x;
      this.spt.y = this.y;
      this.spt.update();

      this.titleObjSpt = new SVGSprite( this.titleObj );
      this.sizeObjSpt = new SVGSprite( this.sizeObj );
      this.updateSizeText();

      this.updateCeilingHeight();

      // this.spt.mouseEnabled = false;
      this.titleObjSpt.mouseEnabled = false;
      this.sizeObjSpt.mouseEnabled = false;
      this.parentLayer.addParts(this);

      this.sptTitle = new SVGSprite(this.titleObj);

      // const scope: RoomText = this;

      this.sptTitle.name = 'title';
      this.sptTitle.doubleClickEnabled = true;

      // this.sptTitle.addEventListener(MouseEvent.DOUBLE_CLICK, function():void
      // {
      //     //Debugger.log("double click ok");
      //     scope.createTextarea();
      // });

      // サイズ表示判別
      if (!this.partnerRoom.itemInfo.text_area_visible) {
        this.sizeObj.style.visibility = 'hidden';
      }
      // 天井
      if (!this.partnerRoom.itemInfo.text_ceiling_visible) {
        this.ceilingObj.style.visibility = 'hidden';
      }
      // 部屋名表示判別
      if (!this.partnerRoom.itemInfo.text_visible) {
        this.hide();
      }

      // 移動
      if (this.autoLayout) {
        this.resetRoomNamePosition();
      }

      if (marietta.webcad.WebCADGlobal.userAgentManager.isEdge) {
        marietta.webcad.WebCADGlobal.scrollerManager.addEventListener(marietta.webcad.flash.events.Event.CHANGE_SCALE, this.changeScaleHandler, this);
      }

      // 部屋名にイベント登録
      // this.titleObj.addEventListener('dblclick', this.createTextarea);
    }

    public update():void{
      this.updateSizeText();
      this.updateCeilingHeight();
    }
    private updateCeilingHeight():void{
      // 天井表記
      const basicHeight:number = marietta.webcad.view.dialog.RoomSetting.getBasicCeilingHeight( this.partnerRoom.itemInfo.floor );
      const ceilingHeight:number = basicHeight-(this.partnerRoom.itemInfo.ceiling_hang_height?this.partnerRoom.itemInfo.ceiling_hang_height:0);
      this.ceilingObj.textContent = `(CH${ceilingHeight})`;
      if( ceilingHeight <= 2000 ){
        this.ceilingObj.style.fill = '#FF0000';
      }else {
        this.ceilingObj.style.fill = '#0000FF';
      }
    }

    private changeScaleHandler(): void {
      const scope: RoomText = this;
      let cc: number = 0;
      //            scope.sizeObj.style.visibility = "hidden";
      scope.spt.onEnterFrame = (): void => {
        cc += 1;
        if (cc > 1) {
          scope.spt.deleteEnterFrame();
          // scope.sizeObj.style.visibility = "visible";
        }
      };
    }

    /**
     * テキスト位置リセット
     * */
    public resetRoomNamePosition(): void {
      if (this.titleObj === null || this.titleObj === undefined) return;
      if (this.sizeObj === null || this.sizeObj === undefined) return;
      if (this.ceilingObj === null || this.ceilingObj === undefined) return;

      // 中心点をみつける
      let minX: number;
      let minY: number;
      let maxX: number;
      let maxY: number;
      for (let i: number = 0; i < this.partnerRoom.itemInfo.dotList.length; i += 1) {
        if (minX === undefined || minX === null || this.partnerRoom.itemInfo.dotList[i].x < minX) minX = this.partnerRoom.itemInfo.dotList[i].x;
        if (minY === undefined || minY === null || this.partnerRoom.itemInfo.dotList[i].y < minY) minY = this.partnerRoom.itemInfo.dotList[i].y;
        if (maxX === undefined || maxX === null || this.partnerRoom.itemInfo.dotList[i].x > maxX) maxX = this.partnerRoom.itemInfo.dotList[i].x;
        if (maxY === undefined || maxY === null || this.partnerRoom.itemInfo.dotList[i].y > maxY) maxY = this.partnerRoom.itemInfo.dotList[i].y;
      }
      // 中点を調べる
      const vectorList = marietta.webcad.util.WebCADUtil.convertDotListToVector2D(this.partnerRoom.itemInfo.dotList);
      const textPos = new graphicLibs.utility.labelPosition().labelPosition(vectorList);
      this.partnerRoom.itemInfo.textPosition = new marietta.core.Point(this.partnerRoom.itemInfo.x + textPos.x,this.partnerRoom.itemInfo.y + textPos.y);

      // 位置調整
      this.move(this.partnerRoom.itemInfo.textPosition.x, this.partnerRoom.itemInfo.textPosition.y);
    }

    /**
     * サイズ用テキストを取得
     * */
    protected updateSizeText() {
      let newString: string;
      if (this.useJyou) {
        const tubo: number = marietta.webcad.util.WebCADUtil.calculateAreaInTsubo(this.partnerRoom.itemInfo.dotList);
        switch (marietta.webcad.WebCADGlobal.language) {
          case 'en':
            if (tubo === Math.round(tubo)) {
              newString = `(${String(tubo)}.0jyou)`;
            } else {
              newString = `(${String(tubo)}jyou)`;
            }
            break;
          default:
            if (tubo === Math.round(tubo)) {
              newString = `(${String(tubo)}.0帖)`;
            } else {
              newString = `(${String(tubo)}帖)`;
            }
            break;
        }
      } else {
        newString = String(`${marietta.webcad.util.WebCADUtil.calculateArea(this.partnerRoom.itemInfo.dotList)}㎡`);
      }
      this.sizeObj.textContent = newString;
      this.currentString = newString;

      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      this.updateTransforms();
      // テキスト同士の整列
      this.alignTexts();

      if (ua.isEdge) {
        this.alignTexts();
        let cc: number = 0;
        const scope: RoomText = this;
        // this.sizeObj.style.visibility = "hidden";
        this.spt.onEnterFrame = (): void => {
          cc += 1;
          if (cc > 1) {
            scope.spt.deleteEnterFrame();
            // scope.sizeObj.style.visibility = "visible";
          }
        };
      }
    }

    /**
     * テキスト同士の整列
     * @param isAutoAlign boolean; default value = false
     * isAutoAlignが使用されますテキストコンテンツの編集後にテキスト位置を更新します
    * */
    public alignTexts(isAutoAlign = false) {
      let bound1: DOMRect = this.titleObj.getBoundingClientRect();
      let bound2: DOMRect = this.sizeObj.getBoundingClientRect();
      let bound3: DOMRect = this.ceilingObj.getBoundingClientRect();
      const scope: RoomText = this;

      let func: Function = function (bound1:DOMRect, bound2:DOMRect, bound3:DOMRect, isGetBound: boolean): void {
        if (isGetBound) {
          bound1 = scope.titleObj.getBoundingClientRect();
          bound2 = scope.sizeObj.getBoundingClientRect();
          bound3 = scope.ceilingObj.getBoundingClientRect();
        }
        const reverseScale:number = 1 / marietta.webcad.WebCADGlobal.scaleSize;
        let w1: number = bound1.width * reverseScale;
        let w2: number = bound2.width * reverseScale;
        let w3: number = bound3.width * reverseScale;
        const roomBound = scope.partnerRoom.getBoundRect();
        let textWidth = w1;
        if (bound1.width < bound1.height) {
          textWidth = bound1.height;
        }
        if( textWidth < bound3.height ) textWidth = bound3.height;
        if ((roomBound.width < roomBound.height) && (roomBound.width < (textWidth)) && scope.rotation !== 0) {
          w1 = bound1.height * reverseScale;
          w2 = bound2.height * reverseScale;
          w3 = bound3.height * reverseScale;
        }
        if (!scope.visible) {
          w1 = 0;
          w2 = 0;
          w3 = 0;
        }
        scope.updateTransforms();
        if (isAutoAlign) scope.resetRoomNamePosition();

        // サイズテキストの整頓
        // テキストのY原点はテキストの下端★！！要注意
        let allHeight = 0;
        if( scope.visible ) allHeight += marietta.webcad.WebCADGlobal.roomtextFontSize;
        if( scope.areaVisible )  allHeight += marietta.webcad.WebCADGlobal.roomtextFontSize;
        if( scope.ceilingHeightVisible )  allHeight += marietta.webcad.WebCADGlobal.roomtextFontSize;

        let startY:number = - allHeight / 2 + marietta.webcad.WebCADGlobal.roomtextFontSize; // Y座標を中央にする
        // 部屋のテキストが非表示の場合はslideYを変更します
        const y1 = scope.areaVisible ? startY : 0;
        const y2 = y1 + (scope.areaVisible ? marietta.webcad.WebCADGlobal.roomtextFontSize:0);
        const y3 = y2 + (scope.ceilingHeightVisible ? marietta.webcad.WebCADGlobal.roomtextFontSize:0);

        scope.titleObj.setAttribute('transform', `translate(-${w1 / 2} , ${y1})`);
        scope.sizeObj.setAttribute('transform', `translate(-${w2 / 2} , ${y2})`);
        scope.ceilingObj.setAttribute('transform', `translate(-${w3 / 2} , ${y3})`);
        scope.updateTransforms();
        if (isAutoAlign) {
          scope.resetRoomNamePosition();
        }
      };

      // WEBCAD-1153対応
      // 直後に処理するとwidthが0になるので、1ミリ秒処理を遅らせる
      if (bound1.width === 0 && bound2.width === 0 && bound3.width === 0 ) {
        func(bound1, bound2, bound3, true);
        window.setTimeout(function () {
          func(bound1, bound2, bound3, true);
        }, 1);
      }
      else {
        func(bound1, bound2, bound3, false);
      }
    }

    /**
     * 移動 XY
     */
    move(x: number, y: number) {
      this.x = x;
      this.y = y;
      this.updateTransforms();
    }

    /**
    * 移動X
    */
    moveX(x: number) {
      this.x = x;
      this.updateTransforms();
    }

    /**
    * 移動Y
    */
    moveY(y: number) {
      this.y = y;
      this.updateTransforms();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      this.spt.element.setAttribute('transform', this.getCurrentTransform());
    }

    /**
     * 現行のTransform
     */
    getCurrentTransform() {
      if (Number.isNaN(this.x)) this.x = 0;
      if (Number.isNaN(this.y)) this.y = 0;
      let bound = this.titleObj.getBoundingClientRect();
      if (this.partnerRoom.itemInfo.text_area_visible || this.partnerRoom.itemInfo.text_ceiling_visible ) bound = this.groupObj.getBoundingClientRect();
      let textWidth = bound.width / marietta.webcad.WebCADGlobal.scaleSize;
      if (bound.width < bound.height) {
        textWidth = bound.height / marietta.webcad.WebCADGlobal.scaleSize;
      }
      let retTransform = '';
      this.rotation = 0;
      retTransform += `translate( ${this.x}, ${this.y} ) `;
      const roomBound = this.partnerRoom.getBoundRect();
      if (roomBound.width < roomBound.height && textWidth > roomBound.width) {
        this.rotation = 270;
        retTransform = '';
        retTransform += `translate( ${this.x}, ${this.y} ) `;
        retTransform += `rotate( ${this.rotation} ) `;
      }
      return retTransform;
    }


    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
      // 表示の再設定
      this.visible = this._visible;

      this.areaVisible = this._areaVisible;
    }

    /**
     * 表示ON
     */
    hide() {
      this.spt.element.style.visibility = 'hidden';
      this.sizeObj.style.visibility = 'hidden';
      this.titleObj.style.visibility = 'hidden';
      this.ceilingObj.style.visibility = 'hidden';
    }

    /**
     * 削除
     */
    deleteMe() {
      this.titleObj.remove();
      this.sizeObj.remove();
      this.ceilingObj.remove();

      this.spt.deleteEnterFrame();
      this.spt.remove();
      this.sptTitle.remove();
      this.parentLayer.deleteItem(this);

      if (marietta.webcad.WebCADGlobal.userAgentManager.isEdge) {
        marietta.webcad.WebCADGlobal.scrollerManager.removeEventListener(marietta.webcad.flash.events.Event.CHANGE_SCALE, this.changeScaleHandler);
      }
    }

    /**
     * テキストのActive・非Active
     */
    setActive(booActive: boolean) {
      // 色の変更
      if (booActive) {
        this.titleObj.setAttribute('fill', '#0000FF');
        this.sizeObj.setAttribute('fill', '#0000FF');
        this.ceilingObj.setAttribute('fill', '#0000FF');

        // this.spt.mouseEnabled = true;
        this.titleObjSpt.mouseEnabled = true;
        this.sizeObjSpt.mouseEnabled = true;

        this.moveTextActive = true;
      } else {
        this.titleObj.setAttribute('fill', '#000000');
        this.sizeObj.setAttribute('fill', '#000000');
        this.ceilingObj.setAttribute('fill', '#000000');

        // this.spt.mouseEnabled = false;
        this.titleObjSpt.mouseEnabled = false;
        this.sizeObjSpt.mouseEnabled = false;

        this.moveTextActive = false;
      }
    }

    /**
     * 移動開始
     */
    moveText() {
      // 基本アクション
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      document.addEventListener('mousedown', this.stopMove);
      this.previousPosition = new marietta.core.Point(this.x, this.y);

      if (ua.isMobile || ua.isTablet) {
        if (marietta.webcad.WebCADGlobal.itemManager.itemController && marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerRoomMobile) {
          marietta.webcad.WebCADGlobal.itemManager.itemController.roomDragger.hide();
        }
        this.spt.element.addEventListener('touchstart', this.startMove, { passive: false });
        document.addEventListener('touchstart', this.stopMove);
      } else {
        this.spt.element.addEventListener('mousedown', this.startMove);
      }
      ua = null;

      // Active表示
      this.setActive(true);
    }

    /**
     * テキスト移動
     * @param MouseEvent
     * */
    startMove = (event: MouseEvent & TouchEvent) => {
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      event.stopImmediatePropagation();
      if (ua.isMobile || ua.isTablet) {
        if (event.touches.length >= 2) {
          return;
        }
        event.preventDefault();
        Stage.refreshStageMouse(<any>event);
      }
      // 元の座標保持
      this.offsetPoint = new marietta.core.Point(marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX - this.x, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY - this.y);

      // ドラッグの開始

      if (ua.isMobile || ua.isTablet) {
        event.stopPropagation();
        event.preventDefault();
        document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
        document.addEventListener('touchend', this.stopMove, { passive: false });
      } else {
        document.addEventListener('mousemove', this.onMouseMoveMe);
        document.addEventListener('mouseup', this.stopMove);
      }
      ua = null;
    }

    /**
     * マウスが移動した
     * @param MouseEvent
     */
    onMouseMoveMe = (e: MouseEvent & TouchEvent) => {
      e.preventDefault();
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;

      this.x = this.parentLayer.spt.mouseX - this.offsetPoint.x;
      this.y = this.parentLayer.spt.mouseY - this.offsetPoint.y;
      this.updateTransforms();
      if (ua.isMobile || ua.isTablet) {
        if (e.touches.length >= 2) {
          return;
        }
        e.preventDefault();
        Stage.refreshStageMouse(<any>e);
      }
    }

    /**
     * テキスト移動終了
     * @param MouseEvent
     * */
    stopMove = () => {
      // ドラッグの終了
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        if (marietta.webcad.WebCADGlobal.itemManager.itemController && marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerRoomMobile) {
          marietta.webcad.WebCADGlobal.itemManager.itemController.roomDragger.show();
        }
        this.spt.element.removeEventListener('touchstart', this.startMove);
        document.removeEventListener('touchmove', this.onMouseMoveMe);
        document.removeEventListener('touchend', this.stopMove);
        document.removeEventListener('touchstart', this.stopMove);
      } else {
        document.removeEventListener('mousemove', this.onMouseMoveMe);
        document.removeEventListener('mouseup', this.stopMove);
        this.spt.element.removeEventListener('mousedown', this.startMove);
      }
      document.removeEventListener('mousedown', this.stopMove);
      ua = null;

      // ActiveOff
      this.setActive(false);

      this.autoLayout = false;

      // ヒストリ
      if (marietta.core.Point.distance(this.previousPosition, new marietta.core.Point(this.x, this.y)) > 0) {
        marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
      }
    }

    public get viewObj(): HTMLElement {
      return this.spt.element;
    }


    /**
     * 出力用座標の取得
     */
    getSavePoint(): marietta.core.Point {
      let saveX = this.x;
      let saveY = -(this.y - marietta.webcad.WebCADGlobal.LAYER_SIZE_H);
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.buildingType === BUILDING_TYPE_MANSION) {
        saveX = marietta.webcad.util.WebCADUtil.convertPixToMM(this.x);
        saveY = -(marietta.webcad.util.WebCADUtil.convertPixToMM(this.y) - marietta.webcad.util.WebCADUtil.convertPixToMM(marietta.webcad.WebCADGlobal.LAYER_SIZE_H));
      }
      return new marietta.core.Point(saveX, saveY);
    }
}
